import { render, staticRenderFns } from "./DetailsComponentSwitch.vue?vue&type=template&id=b10cc090&scoped=true&"
import script from "./DetailsComponentSwitch.vue?vue&type=script&lang=js&"
export * from "./DetailsComponentSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10cc090",
  null
  
)

export default component.exports